import axios from "axios";
import { API_BASE_URL } from "./apiConfig";

const API = API_BASE_URL;

class AuthService {
  getAccessToken() {
    return localStorage.getItem("access_token");
  }

  getRefreshToken() {
    return localStorage.getItem("refresh_token");
  }

  setTokens(accessToken, refreshToken) {
    localStorage.setItem("access_token", accessToken);
    if (refreshToken) {
      localStorage.setItem("refresh_token", refreshToken);
    } else {
      localStorage.removeItem("refresh_token");
    }
  }

  clearTokens() {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
  }

  isAuthenticated() {
    return !!this.getAccessToken();
  }

  // ✅ UPDATED: added role param
  async register(name, email, password, role = "user") {
    const payload = {
      name: name?.trim(),
      email: email?.trim().toLowerCase(),
      password,
      role, // ✅ dynamic role (user / narrator)
    };

    const response = await axios.post(`${API}/auth/register`, payload, {
      headers: { "Content-Type": "application/json" },
    });

    return response.data;
  }

  async login(email, password) {
    const payload = {
      email: email?.trim().toLowerCase(),
      password,
    };

    const response = await axios.post(`${API}/auth/login`, payload, {
      headers: { "Content-Type": "application/json" },
    });

    const { access_token, refresh_token } = response.data;
    this.setTokens(access_token, refresh_token);

    return response.data;
  }

  async logout() {
    try {
      const token = this.getAccessToken();
      await axios.post(
        `${API}/auth/logout`,
        {},
        { headers: token ? { Authorization: `Bearer ${token}` } : {} }
      );
    } finally {
      this.clearTokens();
    }
  }

  async getMe() {
    const token = this.getAccessToken();
    const response = await axios.get(`${API}/me`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    return response.data;
  }
}

export default new AuthService();
